/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2020 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { inject } from "mobx-react";
import { AccessibleMarkupCommentNode } from "components/accessibility/AccessibleMarkupCommentNode";
import { withFocusability, withCaretOnFocus } from "containers/accessibility/AccessibleFocusableNodeContainers";
import { simulateClick } from "utils/AccessibilityUtils";

const mapStoresToProps = (stores, ownProps) => ({
  onClick: event => {
    if (ownProps.role === "link") {
      simulateClick(event, ownProps.pageIndex, stores);
      return;
    }
    stores.accessibilityStore.selectComment(ownProps.annotInfo.annotId);
  }
});

const AccessibleMarkupCommentNodeContainer = withCaretOnFocus(
  withFocusability(inject(mapStoresToProps)(AccessibleMarkupCommentNode))
);

export { AccessibleMarkupCommentNodeContainer };
